module.exports = __webpack_public_path__ + "static/media/card-bg-standard.4cd43d29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Plans/card-bg-standard.jpg
// module id = 329
// module chunks = 0